import api from '@/api';

export default {
  namespaced: true,
  state: {
    questionForms: [],
    currentQuestionForm: null,
    isLoading: false,
    error: null,
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      perPage: 10,
      from: 0,
      to: 0
    },
    filters: {
      search: '',
      subject_id: null,
      teacher_id: null,
      difficulty_level: ''
    }
  },
  mutations: {
    SET_QUESTION_FORMS(state, questionForms) {
      state.questionForms = questionForms;
    },
    SET_CURRENT_QUESTION_FORM(state, questionForm) {
      state.currentQuestionForm = questionForm;
    },
    SET_LOADING(state, isLoading) {
      state.isLoading = isLoading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    SET_PAGINATION(state, pagination) {
      state.pagination = pagination;
    },
    SET_FILTERS(state, filters) {
      state.filters = filters;
    },
    ADD_QUESTION_FORM(state, questionForm) {
      state.questionForms.unshift(questionForm);
    },
    UPDATE_QUESTION_FORM(state, updatedQuestionForm) {
      const index = state.questionForms.findIndex(qf => qf.id === updatedQuestionForm.id);
      if (index !== -1) state.questionForms.splice(index, 1, updatedQuestionForm);
    },
    DELETE_QUESTION_FORM(state, questionFormId) {
      state.questionForms = state.questionForms.filter(qf => qf.id !== questionFormId);
    }
  },
  actions: {
    async fetchQuestionForms({ commit, state }, { page = 1, per_page = 10 } = {}) {
      commit('SET_LOADING', true);
      try {
        const response = await api.get('/question-forms', {
          params: {
            page: page || state.pagination.currentPage,
            per_page: per_page || state.pagination.perPage,
            search: state.filters.search,
            subject_id: state.filters.subject_id,
            teacher_id: state.filters.teacher_id,
            difficulty_level: state.filters.difficulty_level
          }
        });
        
        commit('SET_QUESTION_FORMS', response.data.data);
        commit('SET_PAGINATION', {
          currentPage: response.data.meta.current_page,
          totalPages: response.data.meta.last_page,
          totalItems: response.data.meta.total,
          perPage: response.data.meta.per_page,
          from: response.data.meta.from,
          to: response.data.meta.to
        });
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

   async fetchQuestionForm({ commit }, id) {
  commit('SET_LOADING', true);
  try {
    const response = await api.get(`/question-forms/${id}`);
    commit('SET_CURRENT_QUESTION_FORM', {
      ...response.data.data,
      subject: response.data.data.subject || null,
      teacher: response.data.data.teacher || null
    });
  } catch (error) {
    commit('SET_ERROR', error.response?.data?.message || error.message);
    throw error;
  } finally {
    commit('SET_LOADING', false);
  }
},

    async createQuestionForm({ commit }, formData) {
      commit('SET_LOADING', true);
      try {
        const response = await api.post('/question-forms', formData);
        commit('ADD_QUESTION_FORM', response.data.data);
        return response.data;
      } catch (error) {
        if (error.response?.status === 422) {
          throw error.response.data.errors;
        }
        commit('SET_ERROR', error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async updateQuestionForm({ commit }, { id, questionFormData }) {
      commit('SET_LOADING', true);
      try {
        const response = await api.put(`/question-forms/${id}`, questionFormData);
        commit('UPDATE_QUESTION_FORM', response.data.data);
        return response.data;
      } catch (error) {
        if (error.response?.status === 422) {
          throw error;
        }
        commit('SET_ERROR', error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async deleteQuestionForm({ commit }, questionFormId) {
      commit('SET_LOADING', true);
      try {
        await api.delete(`/question-forms/${questionFormId}`);
        commit('DELETE_QUESTION_FORM', questionFormId);
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    setFilters({ commit, dispatch }, filters) {
      commit('SET_FILTERS', filters);
      dispatch('fetchQuestionForms');
    }
  },
  getters: {
    questionForms: state => state.questionForms,
    questionForm: state => state.currentQuestionForm,
    isLoading: state => state.isLoading,
    error: state => state.error,
    pagination: state => state.pagination
  }
};